import { textDecomposeMap } from './decomposer';
import { textComposeMap } from './composer';

export const text = {
  decomposeMap: textDecomposeMap,
  composeMap: textComposeMap,
};
